import CloseIcon from '@mui/icons-material/Close'
import { Box, Button, DialogContent, IconButton, Typography, styled, useMediaQuery } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import theme from '../../../../../config/theme'

export const StyledButton = styled(Button)(() => ({
  background: 'linear-gradient(158.55deg, #202CD3 5.3%, #02E39F 102.34%)',
  borderRadius: '75px',
  border: 'none',
  color: '#fff',
  textTransform: 'none',
  fontSize: '0.875rem',
  fontWeight: 600,
  padding: '10px 30px',
  '&:hover': {
    background: 'linear-gradient(158.55deg, #02E39F 5.3%, #202CD3 102.34%)',
    border: 'none'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.7rem'
  }
})) as typeof Button

interface GetHelpModalProps {
  isOpen: boolean
  onClose: (log?: boolean) => void
  onContinue: () => void
  currentPlanName: string
  currentTermEndsAt: string
}

function GetHelpModal({ isOpen, onClose, onContinue }: Readonly<GetHelpModalProps>) {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const contactSupport = () => {
    window.open('https://support.photobucket.com/hc/en-us', '_blank')
    onClose(true)
  }

  return (
    <Dialog data-test="get-help-modal" open={isOpen} onClose={() => onClose(true)} maxWidth="sm">
      <DialogTitle sx={{ textAlign: 'left', paddingBottom: '8px', position: 'relative' }}>
        <Typography color="primary" sx={{ fontWeight: '600', fontSize: '20px' }}>
          Get help!
        </Typography>
        <IconButton
          aria-label="close"
          onClick={() => onClose(true)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (icontheme) => icontheme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: '24px', textAlign: 'center' }}>
        <Box sx={{ marginBottom: '16px' }}>
          <img
            src="https://content.photobucket.com/img/subscription/gradient_warning_icon.png"
            alt="Warning Icon"
            style={{ width: isMobile ? '50px' : '100px', height: isMobile ? '50px' : '100px' }}
          />
        </Box>
        <Typography sx={{ marginBottom: '16px', fontSize: '14px', lineHeight: '20px' }}>
          We&apos;re sorry to learn that you&apos;re having a frustating experience. It is our mission to provide all of our customers with an amazing
          experience. If there&apos;s anything we can help with, please contact our Support Team below.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: isMobile ? '' : '5px' }}>
          <Button
            data-testid="continue-cancellation-help-modal"
            sx={{ minWidth: '120px', fontWeight: '600', padding: '8px 16px', fontSize: isMobile ? '0.7rem' : '0.875rem' }}
            color="secondary"
            onClick={onContinue}
          >
            Continue to Cancel
          </Button>
          <StyledButton
            data-testid="contact-support-button-help-modal"
            sx={{ minWidth: '40px', fontWeight: '600', padding: '8px 16px' }}
            color="error"
            onClick={contactSupport}
          >
            Contact Support
          </StyledButton>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default GetHelpModal
